import { storage } from "../../utils/storage";

/**
 * Download the contribution report for the current filters: a CSV file, or a printable page.
 * Rejects with a readable message when the server refuses, so the caller can show it.
 */
export async function downloadContributionReport(format, filters = {}) {
  const params = new URLSearchParams({ guard: "staff", format });
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") params.set(key, value);
  });

  const token = storage["cookieStorage"].get("access_token");
  const url = `${process.env.REACT_APP_BASE_URL}/cooperatives/member_contributions/contribution-history-v2/download?${params.toString()}`;
  const response = await fetch(url, { headers: { Authorization: `Bearer ${token}`, Accept: "application/json" } });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body?.message || "We couldn't prepare the report. Try again.");
  }

  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(blob);

  if (format === "pdf") {
    const opened = window.open(blobUrl, "_blank");
    if (!opened) throw new Error("Allow pop-ups to see the printable report.");
    return;
  }

  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = `Contributions_${new Date().toISOString().split("T")[0]}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
}
